<head>
  <title>Finding Details Report</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb *ngIf="refreshbreadcrumb"></app-breadcrumb>
<br>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row">
  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Finding'">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email" id="groupNameAlert"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')"
          [disabled]="isDropdownDisabled">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2">
        <label for="email"><b>Specify Interval</b></label>&nbsp;
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="specificIntervalVal" (change)="specificIntervalFun($event)">
            <span class="active-inActive-container" *ngIf="specificIntervalVal" style="color: green;">Yes</span>
            <span *ngIf="!specificIntervalVal" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email"><b>Date Range</b> <span class="mandatory-symbol">*</span>: </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedDateRangeValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of dateRangeValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2" *ngIf="specificIntervalVal">
        <label for="email"><b>From Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
      </div>
      <div class="col-md-2" *ngIf="specificIntervalVal">
        <label for="email"><b>To Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email"><b>Interval</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedIntervalValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of intervalValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2">
        <label for="email"><b>Show BA Chart</b></label>&nbsp;
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="showBAChart">
            <span class="active-inActive-container" *ngIf="showBAChart" style="color: green;">Yes</span>
            <span *ngIf="!showBAChart" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-3" *ngIf="!showBAChart">
        <div><label for="email"><b>Annual Ref No</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="annualRefNo" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-annualRefNo-search')" (keydown.enter)="focusSearch('focus-annualRefNo-search')">
          <input type="search" id="focus-annualRefNo-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onAnnualRefNoSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of uniqueAnnualRefNo | assessmentSearch : groupSearchText" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3" *ngIf="!showBAChart">
        <div><label for="email"><b>Sub Group Name</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="subGroupName" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-subGroupName-search')" (keydown.enter)="focusSearch('focus-subGroupName-search')">
          <input type="search" id="focus-subGroupName-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onuniqueSubGroupNameSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of uniqueSubGroupName | assessmentSearch : groupSearchText" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>

      </div>
      <div class="col-md-3" *ngIf="!showBAChart">
        <div><label for="email"><b>{{this.qmsservice.moduleName}} ID.</b> : </label></div>
        <input type="text" class="form-control" style="padding: 6px 20px;" [(ngModel)]="activityId"
          placeholder="Enter ID">
      </div>
    </div>
    <br><br><br>
    &nbsp; &nbsp; &nbsp;
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genFindnigReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Followup'">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email" id="groupNameAlert2"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')"
          [disabled]="isDropdownDisabled">
          <input type="search" id="focus-group-search1" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2">
        <label for="email"><b>Specify Interval</b></label>&nbsp;
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="specificIntervalVal" (change)="specificIntervalFun($event)">
            <span class="active-inActive-container" *ngIf="specificIntervalVal" style="color: green;">Yes</span>
            <span *ngIf="!specificIntervalVal" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email"><b>Date Range</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedIntervalValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of intervalValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2" *ngIf="specificIntervalVal">
        <label for="email"><b>From Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
      </div>
      <div class="col-md-2" *ngIf="specificIntervalVal">
        <label for="email"><b>To Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email"><b>Interval</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedIntervalValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of intervalValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email"><b>Annual Ref No</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="annualRefNo" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-annualRefNo-search')" (keydown.enter)="focusSearch('focus-annualRefNo-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onAnnualRefNoSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of uniqueAnnualRefNo | assessmentSearch : groupSearchText" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email"><b>Sub Group Name</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="subGroupName" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-subGroupName-search')" (keydown.enter)="focusSearch('focus-subGroupName-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onuniqueSubGroupNameSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of uniqueSubGroupName | assessmentSearch : groupSearchText" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email"><b>{{this.qmsservice.moduleName}} ID.</b> : </label></div>
        <input type="text" class="form-control" style="padding: 6px 20px;" [(ngModel)]="activityId"
          placeholder="Enter ID">
      </div>
    </div>
    <br><br><br> &nbsp; &nbsp;
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genFindnigReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-8" *ngIf="qmsservice.reportFor == 'Recommendation'">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email" id="groupNameAlert1"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
        </div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')"
          [disabled]="isDropdownDisabled">
          <input type="search" id="focus-group-search11" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email"><b>Annual Ref No</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="annualRefNo" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-annualRefNo-search')" (keydown.enter)="focusSearch('focus-annualRefNo-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onAnnualRefNoSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of uniqueAnnualRefNo | assessmentSearch : groupSearchText" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>

      </div>
      <div class="col-md-3">
        <div><label for="email"><b>Sub Group Name</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="subGroupName" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-subGroupName-search')" (keydown.enter)="focusSearch('focus-subGroupName-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onuniqueSubGroupNameSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of uniqueSubGroupName | assessmentSearch : groupSearchText" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>

      </div>
      <div class="col-md-3">
        <div><label for="email"><b>{{this.qmsservice.moduleName}} ID.</b> : </label></div>
        <input type="text" class="form-control" style="padding: 6px 20px;" [(ngModel)]="activityId"
          placeholder="Enter ID">
      </div>
    </div>
    <br><br><br> &nbsp; &nbsp;
    <div class="row" d-flex align-items-center>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genFindnigReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <h3 class="reports_title">Reports</h3>
    <div class="d-flex justify-content-between">
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{'active':this.qmsservice.reportFor === 'Default'}"
        (click)="moreActivityReportDetails('Default')" (keydown.enter)="moreActivityReportDetails('Default')">
        <div class="reports_block">
          <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
        </div>
        <p class="report_subtext">Default</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Performance'}"
        (click)="moreActivityReportDetails('Performance')" (keydown.enter)="moreActivityReportDetails('Performance')"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/cr_performance.svg" width="16px" height="16px" alt="CR Performance">
        </div>
        <p class="report_subtext">{{qmsservice.moduleName}} Performance</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Pending Actions'}"
        (click)="moreActivityReportDetails('Pending Actions')"
        (keydown.enter)="moreActivityReportDetails('Pending Actions')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/pending.svg" width="16px" height="16px" alt="Pending Actions">
        </div>
        <p class="report_subtext">Pending Actions</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4" *ngIf="qmsservice.moduleName !='AU'">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Extension'}"
        (click)="moreActivityReportDetails('Extension')" (keydown.enter)="moreActivityReportDetails('Extension')"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/extension.svg" width="16px" height="16px" alt="Extension">
        </div>
        <p class="report_subtext">Extension</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Effectiveness Check'}"
        (click)="moreActivityReportDetails('Effectiveness Check')"
        (keydown.enter)="moreActivityReportDetails('Effectiveness Check')" style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='AU' && qmsservice.moduleName !='OOS' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/DMS/effectiveness_check.svg" width="16px" height="16px" alt="Effectiveness check">
        </div>
        <p class="report_subtext">Effectiveness Check</p>
      </div>
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{'active':this.qmsservice.reportFor === 'Overdue'}"
        (click)="moreActivityReportDetails('Overdue')" (keydown.enter)="moreActivityReportDetails('Overdue')"
        style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName =='QI' || qmsservice.moduleName =='IN' || qmsservice.moduleName =='CC'">
        <div class="reports_block">
          <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Overdue">
        </div>
        <p class="report_subtext">Overdue</p>
      </div>
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{'active':this.qmsservice.reportFor === 'Action'}"
        (click)="moreActivityReportDetails('Action')" (keydown.enter)="moreActivityReportDetails('Action')"
        style=" cursor: pointer;" *ngIf="qmsservice.moduleName !='AU'">
        <div class="reports_block">
          <img src="../../assets/img/DMS/actions.svg" width="16px" height="16px" alt="Action">
        </div>
        <p class="report_subtext">Actions</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4" *ngIf="qmsservice.moduleName =='AU'">
      <div class="d-flex gap-2 align-items-center report" [ngClass]="{'active':this.qmsservice.reportFor === 'Finding'}"
        (click)="auditFindingReportDetails('Finding')" (keydown.enter)="auditFindingReportDetails('Finding')"
        style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/loupe.png" width="16px" height="16px" alt="Finding">
        </div>
        <p class="report_subtext">Finding</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Followup'}" (click)="auditFindingReportDetails('Followup')"
        (keydown.enter)="auditFindingReportDetails('Followup')" style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/arrow.png" width="16px" height="16px" alt="Followup">
        </div>
        <p class="report_subtext">Followup</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Recommendation'}"
        (click)="auditFindingReportDetails('Recommendation')"
        (keydown.enter)="auditFindingReportDetails('Recommendation')" style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/question.png" width="16px" height="16px" alt="Recommendation">
        </div>
        <p class="report_subtext" style="font-size: 8px;">Recommendation</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4" *ngIf="qmsservice.moduleName =='AU'">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'FindingDue'}" (click)="findingDueDate('FindingDue')"
        (keydown.enter)="findingDueDate('FindingDue')" style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/date.png" width="16px" height="16px" alt="FindingDue">
        </div>
        <p class="report_subtext">Finding Due</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'FollowupDue'}" (click)="followupDueDate('FollowupDue')"
        (keydown.enter)="followupDueDate('FollowupDue')" style=" cursor: pointer;"
        *ngIf="qmsservice.moduleName !='CR' && qmsservice.moduleName !='CAPA' && qmsservice.moduleName !='DV' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='CC'">
        <div class="reports_block">
          <img src="../../assets/img/DMS/due-date.png" width="16px" height="16px" alt="FollowupDue">
        </div>
        <p class="report_subtext">Followup Due</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Extension'}"
        (click)="moreActivityReportDetails('Extension')" (keydown.enter)="moreActivityReportDetails('Extension')"
        style=" cursor: pointer;" *ngIf="qmsservice.moduleName !='IN'  && qmsservice.moduleName!='QI' ">
        <div class="reports_block">
          <img src="../../assets/img/DMS/extension.svg" width="16px" height="16px" alt="Extension">
        </div>
        <p class="report_subtext">Extension</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <div *ngIf="qmsservice.moduleName !='AU'" class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Deleted'}" (click)="moreActivityReportDetails('Deleted')"
        (keydown.enter)="moreActivityReportDetails('Deleted')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/delete.svg" width="16px" height="16px" alt="Deleted">
        </div>
        <p class="report_subtext">Deleted</p>
      </div>
      <div
        *ngIf="qmsservice.moduleName !='AU' && qmsservice.moduleName !='CC' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='QI'"
        class="d-flex gap-2 align-items-center report" [ngClass]="{'active':this.qmsservice.reportFor === 'Obsoleted'}"
        (click)="moreActivityReportDetails('Obsoleted')" (keydown.enter)="moreActivityReportDetails('Obsoleted')"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/obsoleted.svg" width="16px" height="16px" alt="Obsoleted">
        </div>
        <p class="report_subtext">Obsoleted</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Milestone'}"
        (click)="moreActivityReportDetails('Milestone')" (keydown.enter)="moreActivityReportDetails('Milestone')"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/milestone.svg" width="16px" height="16px" alt="Milestone">
        </div>
        <p class="report_subtext">Milestone</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Activity Vs User'}"
        (click)="moreActivityReportDetails('Activity Vs User')"
        (keydown.enter)="moreActivityReportDetails('Activity Vs User')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/cr_performance.svg" width="16px" height="16px" alt="Activity Vs User">
        </div>
        <p class="report_subtext">Activity Vs User</p>
      </div>
      <div *ngIf="qmsservice.moduleName =='AU'" class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.qmsservice.reportFor === 'Overdue'}" (click)="moreActivityReportDetails('Overdue')"
        (keydown.enter)="moreActivityReportDetails('Overdue')" style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Overdue">
        </div>
        <p class="report_subtext">Overdue</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <div
        *ngIf="qmsservice.moduleName !='AU' && qmsservice.moduleName !='IN' && qmsservice.moduleName !='QI' && qmsservice.moduleName !='CC'"
        class="d-flex gap-2 align-items-center report" [ngClass]="{'active':this.qmsservice.reportFor === 'Overdue'}"
        (click)="moreActivityReportDetails('Overdue')" (keydown.enter)="moreActivityReportDetails('Overdue')"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/overdue.svg" width="16px" height="16px" alt="Overdue">
        </div>
        <p class="report_subtext">Overdue</p>
      </div>



    </div>
  </div>
</div>
<hr>
<!-- heading End -->
<div class="row" *ngIf="showCharts ">
  <div class="row" *ngIf="qmsservice.reportFor == 'Finding'">
    <div class="col-md-6" *ngIf="findingList.length>0 &&  qmsservice.moduleName=='AU'">
      <div class="border rounded-4 p-2 mb-3">
        <canvasjs-chart [options]="chartOptionsForFinding" [styles]="{width: '100%', height:'250px'}"
          (dblclick)="chartDoubleClick(1)"></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-6" *ngIf="findingList.length==0 &&  qmsservice.moduleName=='AU'">
      <div class="border rounded-4 p-2 mb-3">
        <label for=""
          style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins', sans-serif;color:#0F3659;"><b>Finding</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
      </div>
    </div>
    <div class="col-md-6" *ngIf="severityList.length>0 &&  qmsservice.moduleName=='AU'">
      <div class="border rounded-4 p-2 mb-3">
        <canvasjs-chart [options]="chartOptionsForSeverity" [styles]="{width: '100%', height:'250px'}"
          (dblclick)="chartDoubleClick(2)"></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-6" *ngIf="severityList.length==0 &&  qmsservice.moduleName=='AU'">
      <div class="border rounded-4 p-2 mb-3">
        <label for="Severity"
          style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins', sans-serif;color:#0F3659;"><b>Finding
            Severity</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
      </div>
    </div>

    <div class="col-md-12">
      <div class="border rounded-4 p-2" *ngIf="showBAChart && baList.length>0">
        <canvasjs-chart [options]="chartOptionsForBa" [styles]="{width: '100%', height:'250px'}"
         ></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-12" *ngIf="showBAChart && baList.length==0">
      <div class="border rounded-4 p-2">
        <label for=" "
          style="text-align: left;font-size: 20px; font-weight: normal;font-family: 'Poppins',sans-serif;color:#0F3659;"><b>Bussiness
            Area</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="qmsservice.reportFor == 'Followup'">
    <div class="col-md-12" *ngIf="followupList.length>0 && qmsservice.moduleName=='AU'">
      <div class="border rounded-4 p-2 mb-3">
        <canvasjs-chart [options]="chartOptionsForFollowup" [styles]="{width: '100%', height:'440px'}"></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-6" *ngIf="followupList.length==0 && qmsservice.moduleName=='AU'">
      <div class="border rounded-4 p-2 mb-3">
        <label for=""
          style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins', sans-serif;color:#0F3659;"><b>Followup</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
      </div>
    </div>
  </div>
</div>
<div *ngIf="showTables">
  <div class="table-container" *ngIf="qmsservice.reportFor=='Recommendation' && showNoRecordFoundRecomandation">
    <div class="border rounded-4 p-2 mb-3">
      <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
        <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='5' && !showNoRecordFoundRecomandation">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <table class="vendors-table-container">
      <th id="grid-header-container"
        *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
        [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
        class="sticky-dynamic-col1 dynamic-table-header-style">
        <div>
          <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
          </div>
        </div>
      </th>
      <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
        <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
          class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
    'text-overflow': 'ellipsis',
    'white-space': 'nowrap'}">
          <span *ngIf="key.dataType=='CHECKBOX'">
            <div class="gridCheckBoxes">
              <img *ngIf="list[key.columnsListarray]" alt="" src="../../assets/img/accessSymbol.svg" width="20"
                height="20">
              <img *ngIf="list[key.columnsListarray]==false" alt="" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20">
            </div>
          </span>
          <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData1(list,key.columnsListarray)">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                <span class="ms-1">View</span>
              </button>
            </div>
          </span>

          <span *ngIf="key.columnsListarray=='QMS_ROLES'" title="{{ list[key.columnsListarray] }}">
            {{ list[key.columnsListarray] }}</span>
          <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa'
             && key.columnsListarray!='DESCRIPTION'">{{
            list[key.columnsListarray]}}</span>
          <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
        </td>
      </tr>
    </table>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic5" ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
</div>
<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{clickedType}} : {{clickedVal}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='1' || showReportFlagValue=='4'">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;" class="vendors-table-container">
        <thead style="z-index:9">

          <th id="grid-header-container"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style">
            <div>
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
              </div>
            </div>
          </th>
        </thead>
        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
    'text-overflow': 'ellipsis',
    'white-space': 'nowrap'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt=" " src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" alt=" " src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData1(list,key.columnsListarray)">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>

            <span *ngIf="key.columnsListarray=='FINDING_SHORT_DESCRIPTION'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="viewFindingShortDescription(list[key.columnsListarray])">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>

            <span *ngIf="key.columnsListarray=='RESPONSE_REVIEWER_COMMENTS'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="viewResponseReviewComments(list[key.columnsListarray])">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.columnsListarray=='IMPLEMENTATION_REVIEWER_COMMENTS'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="viewImplementationReviewerComments(list[key.columnsListarray])">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.columnsListarray=='RESPONSE_VERIFICATION_COMMENTS'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="viewResponceVerificationComments(list[key.columnsListarray])">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.columnsListarray=='IMPLEMENTATION_VERIFICATION_COMMENTS'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="viewImplemetationVerificationComments(list[key.columnsListarray])">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.columnsListarray=='QMS_ROLES'" title="{{ list[key.columnsListarray] }}">
              {{ list[key.columnsListarray] }}</span>
            <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' 
          && key.columnsListarray!='FINDING_SHORT_DESCRIPTION' && key.columnsListarray!='RESPONSE_REVIEWER_COMMENTS' && key.columnsListarray!='COMMENTS' && key.columnsListarray!='IMPLEMENTATION_REVIEWER_COMMENTS' && key.columnsListarray!='RESPONSE_VERIFICATION_COMMENTS'
          && key.columnsListarray!='IMPLEMENTATION_VERIFICATION_COMMENTS'">{{ list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='44'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('auId', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Finding ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('findingId', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Followup ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('followupId', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('annualRefNo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Due Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('dueDate', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To User Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('assignedToUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('assignedToDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To User Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('assignedToUserDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Responses Pending</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('responsesPending', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('completedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('comments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems6.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems6; let idx = index;">
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.findingId }}</td>
          <td class="row-data">{{ listOfUsersData.followupId }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.auditDepartment }}</td>
          <td class="row-data">{{ listOfUsersData.dueDate | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.assignedToUserName }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToDepartment }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToUserDetails }}</td>
          <td class="row-data">{{ listOfUsersData.responsesPending }}</td>
          <td class="row-data">{{ listOfUsersData.completedOn }}</td>
          <td class="row-data">{{ listOfUsersData.comments }}</td>
          <td class="row-data">{{ listOfUsersData.createdOn| date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.createdByName }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.updatedByName }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage6(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic6">
            <button ngbDropdownItem (click)="paginationCall6(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall6(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall6(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!-- Zoom start -->
<ng-template #reportPopupForZoom>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupForZoomFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"></label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="row">
    <div class="col-md-12" *ngIf="clickedChartVal==1">
      <canvasjs-chart [options]="chartOptionsForFindingZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" *ngIf="clickedChartVal==2">
      <canvasjs-chart [options]="chartOptionsForSeverityZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='1' || showReportFlagValue=='4'">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <table class="vendors-table-container">
      <th id="grid-header-container"
        *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
        [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
        class="sticky-dynamic-col1 dynamic-table-header-style">
        <div>
          <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
          </div>
        </div>
      </th>
      <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
        <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
          class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
    'text-overflow': 'ellipsis',
    'white-space': 'nowrap'}">
          <span *ngIf="key.dataType=='CHECKBOX'">
            <div class="gridCheckBoxes">
              <img *ngIf="list[key.columnsListarray]" alt=" " src="../../assets/img/accessSymbol.svg" width="20"
                height="20">
              <img *ngIf="list[key.columnsListarray]==false" alt=" " src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20">
            </div>
          </span>
          <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData1(list,key.columnsListarray)">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                <span class="ms-1">View</span>
              </button>
            </div>
          </span>
          <span *ngIf="key.columnsListarray=='FINDING_SHORT_DESCRIPTION'">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="viewFindingShortDescription(list[key.columnsListarray])">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                <span class="ms-1">View</span>
              </button>
            </div>
          </span>
          <span *ngIf="key.columnsListarray=='COMMENTS'">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="viewComments(list[key.columnsListarray])">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                <span class="ms-1">View</span>
              </button>
            </div>
          </span>
          <span *ngIf="key.columnsListarray=='RESPONSE_REVIEWER_COMMENTS'">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="viewResponseReviewComments(list[key.columnsListarray])">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                <span class="ms-1">View</span>
              </button>
            </div>
          </span>
          <span *ngIf="key.columnsListarray=='IMPLEMENTATION_REVIEWER_COMMENTS'">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="viewImplementationReviewerComments(list[key.columnsListarray])">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                <span class="ms-1">View</span>
              </button>
            </div>
          </span>
          <span *ngIf="key.columnsListarray=='RESPONSE_VERIFICATION_COMMENTS'">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="viewResponceVerificationComments(list[key.columnsListarray])">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                <span class="ms-1">View</span>
              </button>
            </div>
          </span>
          <span *ngIf="key.columnsListarray=='IMPLEMENTATION_VERIFICATION_COMMENTS'">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="viewImplemetationVerificationComments(list[key.columnsListarray])">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="view">
                <span class="ms-1">View</span>
              </button>
            </div>
          </span>
          <span *ngIf="key.columnsListarray=='QMS_ROLES'" title="{{ list[key.columnsListarray] }}">
            {{ list[key.columnsListarray] }}</span>
          <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' 
          && key.columnsListarray!='FINDING_SHORT_DESCRIPTION' && key.columnsListarray!='RESPONSE_REVIEWER_COMMENTS' && key.columnsListarray!='COMMENTS' && key.columnsListarray!='IMPLEMENTATION_REVIEWER_COMMENTS' && key.columnsListarray!='RESPONSE_VERIFICATION_COMMENTS'
          && key.columnsListarray!='IMPLEMENTATION_VERIFICATION_COMMENTS'">{{ list[key.columnsListarray]}}</span>
          <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
        </td>
      </tr>
    </table>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='44'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('auId', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Finding ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('findingId', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Followup ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('followupId', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Sub Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('subGroupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Annual Ref No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('annualRefNo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Audit Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('auditDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Due Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('dueDate', $event,'d')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To User Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('assignedToUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To Department</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('assignedToDepartment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assigned To User Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('assignedToUserDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Responses Pending</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('responsesPending', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('completedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('comments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems6.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems6; let idx = index;">
          <td class="row-data">{{ listOfUsersData.auId }}</td>
          <td class="row-data">{{ listOfUsersData.findingId }}</td>
          <td class="row-data">{{ listOfUsersData.followupId }}</td>
          <td class="row-data">{{ listOfUsersData.subGroupName }}</td>
          <td class="row-data">{{ listOfUsersData.annualRefNo }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.auditDepartment }}</td>
          <td class="row-data">{{ listOfUsersData.dueDate | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.assignedToUserName }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToDepartment }}</td>
          <td class="row-data">{{ listOfUsersData.assignedToUserDetails }}</td>
          <td class="row-data">{{ listOfUsersData.responsesPending }}</td>
          <td class="row-data">{{ listOfUsersData.completedOn }}</td>
          <td class="row-data">{{ listOfUsersData.comments }}</td>
          <td class="row-data">{{ listOfUsersData.createdOn| date:'dd-MMM-yyyy HH:mm:ss' }}</td>
          <td class="row-data">{{ listOfUsersData.createdByName }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.updatedByName }}</td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
      </nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage6(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic6">
            <button ngbDropdownItem (click)="paginationCall6(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall6(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall6(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupForZoomFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 12 columns for a cleaner and more readable PDF
      </span>
    </label>
  </div>
  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Report Logo</label>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
            (keydown.enter)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="row justify-content-md-center">
          <div class="col-sm-4">
            <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
          </div>
          <div class="col-sm-8">
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
              (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
                (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Is Save Report?</label>
        </div>
        <div class="col-sm-8">
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
            <ng-container *ngIf="isSaveReport; else noisSaveReport">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noisSaveReport>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="isSaveReport">
        <div class="col-sm-4">
          <label for="email">Report Name</label>
        </div>
        <div class="col-sm-8">
          <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label id="pdf-select-all" for="email">Select Column(s)</label><span class="mandatory-symbol">*</span>
        </div>
        <mat-select matInput multiple placeholder="Select" #pdf [(ngModel)]="selectedColumns"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfColumnSelection" (change)="toggleAllSelection('pdf')"> Select
              All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : departmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{item.displayExp}}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>